import { configureStore } from '@reduxjs/toolkit';
import navReducer from './navSlice';
import configReducer from './configSlice';

export default configureStore({
  reducer: {
    nav: navReducer,
    config: configReducer
  },
});
